import { useNavigate } from 'react-router'
import { toast } from 'react-toastify'
import { Checkout } from 'depoto-core'
import { useCore } from './core'
import { Schema } from '../utils'

// checkout could have been closed on another device, so check fresh state from server before selling
export const useEnsureCheckoutOpen = () => {
  const { core, checkouts, setCheckouts, selectedCheckoutId, setSelectedCheckoutId } = useCore()
  const navigate = useNavigate()

  return async (): Promise<boolean> => {
    let checkout: Checkout
    try {
      checkout = await core.services.checkout.getById(Number(selectedCheckoutId), Schema.checkout.detail)
    } catch {
      toast.error('Nepodařilo se ověřit stav pokladny')
      return false
    }
    if (!checkout?.id) {
      toast.error('Nepodařilo se ověřit stav pokladny')
      return false
    }
    const isOpen = checkout.currentClosing?.dateOpen && !checkout.currentClosing?.dateClosed
    if (isOpen) return true

    setCheckouts(checkouts.map(c => c.id === checkout.id ? checkout : c))
    toast.warn(`Pokladna ${checkout.name} je uzavřená, nejprve ji otevřete`, { toastId: `checkout-closed-${checkout.id}` })
    setSelectedCheckoutId(undefined)
    navigate(`/checkout-open/${checkout.id}`)
    return false
  }
}
